module.exports = __webpack_public_path__ + "img/2024122601.bcfdd596.png";